import templateUrl from "emun.cart/cart-item-quick-view-prompt.htm";
import open from "webmodals/open";
import basicController from "servicestack/basic.controller.properties";
import Product from "emun.shopping/product.model";
import Design from "emun.on-demand/lib/design";
import modals from "webmodals/modals";
import cartConfig from "emun.cart/cart.config";
import configuratorSettings from "emun.products/configurator/product-configurator.config";
import $session from "servicestack/session";
import addCommitmentPrompt from "emun.order/add-commitment-prompt";
import AutoQuery from "servicestack/auto-query/auto-query";
import sortBy from "lodash/sortBy";

export default ({
  size = "xl cart-item-quick-view",
  backdrop = "true",
  placement = "center",
  preventAutoHeight = true,
  product = { qtyToAdd: 1 },
  products = [product],
  productIds = products.map((p) => p.id),
  cartItem = {},
  values = cartItem.options || [],
  optionGroupList = cartItem.optionGroupList,
  add = !(cartItem.position > 0),
  quantity = cartItem.qtyPurchased || product.minimumOrderQty || 1,
  okButtonText = add ? "Add" : "Save",
  title = `${product.optionGroup ? "Configure" : add ? "Add" : "Edit"} ${
    product.id
  }`,
}) =>
  open({
    size,
    backdrop: 'static',
    templateUrl,
    // placement,
    controller() {
      const $ctrl = this;
      basicController($ctrl);
      console.warn("cart-item-quick-view-prompt", {
        $ctrl,
        productIds,
        products,
        cartItem,
        product,
        values,
      });
      // console.debug(templateUrl, { cartItem, product, values });
      $ctrl.preventAutoHeight = preventAutoHeight;
      if (products.length > 1) $ctrl.productIds = Array.isArray(products) ? products.map((m) => m.id) : [];
      else $ctrl.productIds = Array.isArray(productIds) ? productIds : [];
      $ctrl.configuratorSettings = configuratorSettings;
      $ctrl.cartItem = cartItem;
      $ctrl.add = add;
      $ctrl.quantity = quantity;
      $ctrl.values = values;
      $ctrl.optionGroupList = optionGroupList;
      $ctrl.title = title;
      $ctrl.okButtonText = okButtonText;
      $ctrl.nav = new CartItemQuickViewNav($ctrl);
      $ctrl.cartConfig = cartConfig;
      $ctrl.config = cartConfig;
      $ctrl.product = product;
      Product.get(product.id).then((np) => {
        //console.debug("np", np);
        $ctrl.ready = !!product;
        if (!np.$faked) {
          $ctrl.product = new Product({ ...product, ...np });
          if (!$ctrl.cartItem) $ctrl.cartItem = $ctrl.product.getCartItem();
        }
        $ctrl.infoCollapsed = $ctrl.product.isConfigurable();
        $ctrl.title = `${
          $ctrl.product.isConfigurable() ? "Configure" : add ? "Add" : "Edit"
        } ${$ctrl.product.id}`;
      });
      $ctrl.cartItem.minShipDate = $ctrl.$cart.today;
      if (
        $ctrl.cartItem.product &&
        moment.utc($ctrl.cartItem.product.shipOn) > $ctrl.$cart.today
      ) {
        $ctrl.cartItem.minShipDate = moment.utc($ctrl.cartItem.product.shipOn);
      }

      $ctrl.onProductSelected = function (args) {
        const $ctrl = this;
        $ctrl.nav.selectProduct(args.productId);
      };

      $ctrl.getOptions = function (replacePredecessor) {
        const $ctrl = this;
        const designer = $ctrl.designer;
        designer.status = "saving";
        return designer.save(replacePredecessor).then(() => {
          designer.isDirty = false;
          let compositeId = {
            fieldId: "CompositeId",
            valueId: designer.composite.id,
          };
          let compositeImageUrl = {
            fieldId: "CompositeImageUrl",
            valueId: designer.composite.url.replace("design.json", "hires.jpg"),
          };
          let packageId = {
            fieldId: "PackageId",
            valueId: designer.packageId,
          };
          let od = {
            fieldId: "OnDemand",
            valueId: {},
          };
          let customUrl = {
            fieldId: "CustomUrl",
            valueId: "",
          };
          let vm = {
            fieldId: "ValidationMessages",
            valueId: [],
          };
          designer.designs.forEach((d) => {
            vm.valueId = vm.valueId.concat(d.validationMessages);
            var x = (od.valueId[d.areaId] = {
              id: d.id,
              euid: d.euid,
              label: d.label,
              //description: d.description,
              width: d.width,
              height: d.height,
              background: d.background,
              validationMessages: d.validationMessages,
              url: d.url,
              //images: d.images,
              overlayIds: Object.keys(d.overlayImages || {}),
              underlayIds: Object.keys(d.underlayImages || {}),
            });
            var oId = x.overlayIds.concat(x.underlayIds)[0];
            if (!customUrl.valueId)
              customUrl.valueId = d.url.replace(
                "design.json",
                oId + "/hires.jpg"
              );
          });
          od.valueId = JSON.stringify(od.valueId);
          vm.valueId = vm.valueId.join("|");
          return [packageId, compositeImageUrl, compositeId, customUrl, od, vm];
        });
      };
      $ctrl.mapProducts = function (products) {
        let $ctrl = this;
        // console.debug("mapProducts$ctrl", $ctrl);
        return products.map((_p) => {
          const p = new Product(_p);
          // p.switch = () => $ctrl.switchProduct(p.id);
          p.$ctrl = $ctrl;
          // console.debug("mapProducts", p);
          return p;
        });
      }
      $ctrl.addAndClose = function (skipOptions) {
        let $ctrl = this;
        $ctrl.forceClose = true;
        $ctrl.nav.submit(skipOptions);
      };
      $ctrl.initializeDesigner = function (designer) {
        let $ctrl = this;
        $ctrl.designer = designer;
        let designId = $ctrl.product.designId;
        let productId = $ctrl.product.productId;
        let position = $ctrl.cartItem.position;
        let cartItem = $ctrl.cartItem;
        designer.ready = false;
        designer.sku = productId;
        designer.isLoading = true;
        designer.status = "loading";

        $ctrl.$cart.$$load.then(() => {
          designer.designs = [];
          designer.areas = $ctrl.product.areas;
          designer.productTemplateId = $ctrl.product.productTemplateId;
          designer.label = $ctrl.product.label;
          designer.packageId = designer.onDemandProductId =
            $ctrl.product.onDemandProductId;
          ($ctrl.product.areas || []).forEach((a) => {
            if (a.copyFrom) return;
            let d = Design.fromArea(
              a,
              { label: $ctrl.product.shortDescription },
              cartItem.renderingUrl && { url: cartItem.renderingUrl },
              cartItem.designMap && cartItem.designMap[a.euid]
            );
            designer.designs.push(d);
          });

          if (designer.designs.length) {
            designer.activate(designer.designs[0]);
            designer.ready = true;
            designer.isLoading = false;
            designer.status = "ready";
          } else {
            designer.ready = false;
            designer.isLoading = true;
            designer.status = "no designs";
          }
          $ctrl.$pageConfig.goTop();
        });
      };
      $ctrl.addCommitment = function() {
        let $ctrl = this;
        return addCommitmentPrompt({
          product: $ctrl.product,
        }).then((result) => console.debug("result", result));
      }

      $ctrl.sizeOptionsQuery = new AutoQuery({
        url: `QueryProducts.json?src=Sizes`,
        criteria: {
          cartId: this.$cart.id,
        },
        tagCriteria: {
          Sizes: this.product.tags.Sizes,
        },
        autoLoad: !!this.product.tags.Sizes,
        onLoaded(args) {
          const products = $ctrl.mapProducts(args.results);
        
          $ctrl.sizeOptions = sortBy(products, [
            p => (p.tags && p.tags.SizePosition && p.tags.SizePosition[0]) || 0,
            p => (p.tags && p.tags.SizeLabel && p.tags.SizeLabel[0]) || '',
          ]);
        
          // const clothingLabels = ['xs', 'sm', 'md', 'l', 'xl', 'xxl'];
          // $ctrl.hasClothingSizes = $ctrl.sizeOptions.some(p => {
          //   const labels = (p.tags && p.tags.SizeLabel) || [];
          //   return labels.some(label => clothingLabels.includes(label.toLowerCase().trim()));
          // });
          console.debug("BL*** $ctrl.sizeOptions", $ctrl.sizeOptions);
        }
      });

      
      $ctrl.colorOptionsQuery = new AutoQuery({
        url: `QueryProducts.json?src=OptionLink&IdNotEqualTo=${$ctrl.product.id}`,
        criteria: {
          cartId: $ctrl.$cart.id,
        },
        tagCriteria: {
          OptionLink: $ctrl.product.tags.OptionLink,
        },
        take: 1000,
        pageSize: 1000,
        autoLoad: !!$ctrl.product.tags.OptionLink,
        onLoaded: (args) => ($ctrl.colorOptions = $ctrl.mapProducts(args.results)),
      });
  

      $ctrl.kitComponentsQuery = new AutoQuery({
        url: "QueryProducts.json",
        pageSize: 100,
        orderBy: "Id",
        criteria: {
          KitId: product.id,
          IncludeInactive: true,
        },
        autoLoad: this.product.isKit,
        onLoaded: (args) => {
          $ctrl.product.kitComponents = Product.map(args.results);
          $ctrl.kitComponentsRawQuery = new AutoQuery({
            url: "QueryKitComponents.json",
            pageSize: 100,
            orderBy: "Id",
            autoLoad: this.product.isKit,
            onLoaded: (args) => {
              args.results.map(c => {
                  var filteredComponent = $ctrl.product.kitComponents.filter(k => k.id == c.componentId);
                  if (filteredComponent.length > 0) {
                    filteredComponent[0].kitComponentQuantity = c.kitComponentQuantity;
                  }
              });
            },
            criteria: {
              KitId: product.id,
              IncludeInactive: true
            }
          });
        },
      });
    },
    bindToController: true,
    controllerAs: "$ctrl",
  }).result;

class CartItemQuickViewNav {
  constructor($ctrl) {
    this.$ctrl = $ctrl;
    this.productIds = $ctrl.productIds || [];
    this.productMap = {};
    this.products = Product.getByIds(this.productIds).then((products) => {
      for (let p of products) {
        this.productMap[p.id] = p;
      }
      //console.debug("productMap", this.productMap);
    });
    $ctrl.$on("closeQuickView", () =>
      $ctrl.$close()
    );
  }

  submit(skipOptions) {
    const { $ctrl } = this;
    if (
      $ctrl.product.meta.MaxNumLines &&
      $ctrl.cartConfig.renderPersonalization
    ) {
      $ctrl.designer.status = "uploading";
      return $ctrl
        .getOptions(false)
        .then(
          (productOptions) => {
            $ctrl.designer.status = "adding to cart";
            $ctrl.cartItem.options = productOptions;
          },
          (show) => {
            if (show)
              modals.alert(
                "Please try again in a few moments.",
                "Could not save design"
              );
          }
        )
        .then(() => {
          $ctrl.designer.status = "ready";
          const item = {
            ...$ctrl.cartItem,
            options: ($ctrl.configurator || $ctrl.cartItem || {}).options,
            optionGroupList: ($ctrl.configurator || $ctrl.cartItem || {})
              .optionGroupList,
          };
          //   return console.debug("submit", item);
          const call =
            item.position > 0
              ? $ctrl.$cart.changeOptions(item)
              : $ctrl.$cart.addItem(item, $ctrl.product, false);

          call.then((res) => {
            if ($ctrl.configurator) $ctrl.configurator.reset();
            cartConfig.closeQuickViewOnSubmit || $ctrl.forceClose
              ? $ctrl.$close(res)
              : false
          });

        });
    } else {
      // console.debug(
      //   "11$ctrl.cartItem",
      //   $ctrl.cartItem,
      //   $ctrl.cartItem.product,
      //   $ctrl.product
      // );
      if (!$ctrl.cartItem.product) {
        $ctrl.cartItem.product = $ctrl.product;
      }
      const item = {
        ...$ctrl.cartItem,
        options: ($ctrl.configurator || $ctrl.cartItem || {}).options,
        optionGroupList: ($ctrl.configurator || $ctrl.cartItem || {})
          .optionGroupList,
      };
      //console.debug("item", item);
      //   return console.debug("submit", item);
      const call =
        item.position > 0 && !$ctrl.product.meta.MaxNumLines
          ? $ctrl.$cart.changeOptions(item)
          : $ctrl.$cart.addItem(item, $ctrl.product, skipOptions);

      call.then((res) => {
        if ($ctrl.configurator) $ctrl.configurator.reset();
        cartConfig.closeQuickViewOnSubmit || $ctrl.forceClose || $ctrl.okButtonText == 'Save'
          ? $ctrl.$close(res)
          : this.selectProduct($ctrl.product.id)
      });
    }
  }
  getProductIndex(id) {
    const { $ctrl } = this;
    return $ctrl.productIds.indexOf(id);
  }
  canGoNext() {
    const { $ctrl } = this;
    $ctrl.productIndex = !$ctrl.product
      ? 10000
      : this.getProductIndex($ctrl.product.id);
    return $ctrl.productIndex < $ctrl.productIds.length - 1;
  }
  goNext() {
    const { $ctrl } = this;
    if (this.canGoNext()) {
      //console.debug("goNext", $ctrl.productIndex);
      return this.selectProduct($ctrl.productIds[$ctrl.productIndex + 1]);
    }
  }
  canGoPrev() {
    const { $ctrl } = this;
    $ctrl.productIndex = !$ctrl.product
      ? -1
      : this.getProductIndex($ctrl.product.id);
    return $ctrl.productIndex > 0;
  }
  goPrev() {
    const { $ctrl } = this;
    if (this.canGoPrev()) {
      console.debug("goPrev", $ctrl.productIndex);
      return this.selectProduct($ctrl.productIds[$ctrl.productIndex - 1]);
    }
  }

  productSelected(product) {
    const { $ctrl } = this;
    //console.debug("product", product);
    $ctrl.ready = !!product;
    $ctrl.product = product;
    $ctrl.cartItem = product.getCartItem();
    $ctrl.productIndex = this.getProductIndex(product.id);
    $ctrl.quantity =
      $ctrl.cartItem.qtyPurchased || product.minimumOrderQty || 1;
    //console.debug("$ctrl", $ctrl);
    $ctrl.title = `${
      product.isConfigurable() ? "Configure" : $ctrl.add ? "Add" : "Edit"
    } ${product.id}`;
    $ctrl.allowPriceOverride = false;
    if (
      $session.isAgency() &&
      $ctrl.$cart.vendor &&
      $ctrl.$cart.vendor.allowPriceOverride
    ) {
      $ctrl.allowPriceOverride = true;
    }
    // $ctrl.init();
  }

  hasSize(label) {
    const { $ctrl } = this;
    const option = $ctrl.sizeOptions.filter(o => (o.tags.SizeLabel[0] || '') === label);
    if (option && option.length) return true;
    else return false;
  }

  isSize(label) {
    const { $ctrl } = this;
    const option = $ctrl.sizeOptions.filter(o => (o.tags.SizeLabel[0] || '') === label);
    if (option && option.length && option[0].id == $ctrl.product.id) return true;
    else return false;
  }

  selectSizeOption(label) {
    const { $ctrl } = this;
    const option = $ctrl.sizeOptions.filter(o => (o.tags.SizeLabel[0] || '') === label);
    if (option && option.length) {
      console.debug("BL*** selected option", option[0]);
      $ctrl.nav.selectProduct(option[0].id);
    }
  }
  selectProduct(productId) {
    const { $ctrl } = this;
    console.debug("BL*** productId", productId);
    //console.debug("selectProduct", productId);
    $ctrl.$broadcast("productSelected", { productId });
    $ctrl.add = !$ctrl.$cart.hasItem(productId);
    $ctrl.title = `${$ctrl.add ? "Add" : "Edit"} ${productId}`;
    $ctrl.okButtonText = $ctrl.add ? "Add" : "Save",
    $ctrl.product = null;
    $ctrl.ready = false;
    if (productId in this.productMap) {
      $ctrl.$ioc("$timeout")(
        () => this.productSelected(this.productMap[productId]),
        88
      );
    } else {
      Product.get(productId).then((product) => this.productSelected(product));
    }
  }

	addInterest() {
		const $ctrl = this;
		if ($ctrl.product.isInterested) {
			return $ctrl.$cart.bus.send("RemoveInterest", $ctrl.product.interests[0]).then(function(response) {
				$ctrl.$notify.success(
				  "Item " +
					$ctrl.product.id +
					" removed from interests.",
				  {
					title: "Interests",
					ttl: 2000,
					disableCountDown: true,
				  }
				);
				$ctrl.product.isInterested = false;
				$ctrl.product.interests = [];
				return response.data;
			  });
		} else {
			return $ctrl.$cart.bus.send("AddInterest", {
				RetailerId: $ctrl.$session.meta.CurrentRetailerId,
				ProductId: $ctrl.product.id,
				Quantity: 1
			}).then(function(response) {
				$ctrl.$notify.success(
				  "Item " +
					$ctrl.product.id +
					" added to interests",
				  {
					title: "Interests",
					ttl: 2000,
					disableCountDown: true,
				  }
				);
				$ctrl.product.isInterested = true;
				$ctrl.product.interests = [];
				$ctrl.product.interests.push(response.data);
				return response.data;
			});
		}
	}


}
